/* sp-kit.js v2.4 · self-hosted Shipping Protection · 2026-09-10 (v2.4: hide protection products from search/cards everywhere)
   Keeps exactly one protection line (tier by order value) in the cart while opted in; removes it when opted out.
   Theme-agnostic: listens to common cart events, watches /cart/*.js requests made by anything else (quick-add,
   upsell apps, buy-now) and re-syncs; re-renders the cart via the mode declared on the widget
   (data-sp-refresh = impulse | dawn | focal | section | reload | none); hides the protection line item;
   exposes window.SPKit.sync() for custom flows (e.g. Buy-it-now before redirecting to checkout). */
(function () {
  if (window.SPKit) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var KEY = 'spkit_opt';
  var cfg = null, busy = false, pending = false, waiters = [];
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function widgets() { return Array.prototype.slice.call(document.querySelectorAll('[data-sp-kit]')); }
  function readCfg() {
    var el = document.querySelector('[data-sp-kit]');
    if (!el) return null;
    try { cfg = JSON.parse(el.getAttribute('data-sp-config')); } catch (e) { cfg = null; }
    return cfg;
  }
  function optedIn() {
    var v = null;
    try { v = localStorage.getItem(KEY); } catch (e) {}
    if (v === 'on') return true;
    if (v === 'off') return false;
    return !!(cfg && cfg['default'] === 'on');
  }
  function setOpt(on) {
    try { localStorage.setItem(KEY, on ? 'on' : 'off'); } catch (e) {}
    document.querySelectorAll('[data-sp-toggle]').forEach(function (t) { t.checked = on; });
  }
  function rate() {
    var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return (r && r > 0) ? r : 1;
  }
  function tierFor(usd) {
    if (!cfg || !usd || usd <= 0) return null;
    if (cfg.mode === 'pct') {
      var fee = Math.round(usd * cfg.rate);
      if (fee < cfg.min) fee = cfg.min;
      if (fee > cfg.max) fee = cfg.max;
      var ext = extId(fee);
      if (ext) return { id: ext, label: extLabel(fee), cents: fee * 100, fee: fee };
      while (fee > 0 && !cfg.map[String(fee)]) fee--;
      var m = cfg.map[String(fee)];
      return m ? { id: m[0], label: m[1], cents: fee * 100, fee: fee } : null;
    }
    var t = cfg.tiers, best = null;
    for (var i = 0; i < t.length; i++) {
      if (usd >= t[i].min - 0.005 && usd <= t[i].max + 0.005) return t[i];
      if (!best || t[i].max > best.max) best = t[i];
    }
    return usd > best.max ? best : null;
  }
  var extCache = null;
  function extIds() {
    if (extCache) return extCache;
    var e = cfg && cfg.ext; if (!e || !e.ids || !e.ids.length) return (extCache = []);
    var out = [e.ids[0]]; for (var i = 1; i < e.ids.length; i++) out.push(out[i - 1] + e.ids[i]);
    return (extCache = out);
  }
  function extId(fee) { // variants beyond the 250 the storefront exposes (custom.sp_ext, boss 2026-09-09: no cap)
    var e = cfg && cfg.ext; if (!e || fee < e.from) return null;
    var ids = extIds(); return ids[fee - e.from] || null;
  }
  function extLabel(fee) {
    var ks = Object.keys(cfg.map || {}), top = null;
    for (var i = 0; i < ks.length; i++) if (!top || +ks[i] > +top) top = ks[i];
    var sample = top ? cfg.map[top][1] : '$250';
    var txt = fee.toLocaleString('en-US');
    return sample.replace(/[\d][\d,.]*/, function (m) { return /[.,]\d\d$/.test(m) ? txt + m.slice(-3) : txt; });
  }
  function isProtId(vid) {
    if (cfg.mode === 'pct') { for (var k in cfg.map) if (cfg.map[k][0] === vid) return true; return extIds().indexOf(vid) >= 0; }
    return cfg.tiers.some(function (t) { return t.id === vid; });
  }
  function isProt(item) {
    return item.product_type === cfg.type || (cfg.handle && item.handle === cfg.handle) || isProtId(item.variant_id);
  }
  function req(url, body) {
    return fetch(root + url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-SPKit': '1' },
      body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch(root + 'cart.js?t=' + Date.now(), { credentials: 'same-origin', headers: { 'X-SPKit': '1' } }).then(function (r) { return r.json(); });
  }

  /* ---------- hide the protection line wherever the theme lists cart items ---------- */
  var LINE_SEL = '.cart-item, .cart__item, .cart-drawer__item, .line-item, .cart__row, .cart-line-item, .mini-cart__line-item, [data-cart-item], [data-line-item], .quick-cart__item, .ajaxcart__product, .cart-list__item, li, tr';
  // note: `li`/`tr` also catch search-result list items, which is intended since 0910
  /* 0910 boss: protection products must never be presented online — also hide any search / predictive-search / collection card linking to them (no cfg needed). */
  var HIDE_HANDLES = ['shipping-protection', 'shipping-protection-legacy', 'shipping-protection-1', 'shipping-protection-2', 'shipping-insurance', 'order-armor'];
  var CARD_SEL = '.product-card, .card-wrapper, .card, .grid__item, .product-item, .product-grid-item, .predictive-search__item, .predictive-search__list-item, .search-result, .product, [data-product-card], [data-product-item], [data-product-id], article';
  function hideLines() {
    var handles = cfg && HIDE_HANDLES.indexOf(cfg.handle) < 0 ? HIDE_HANDLES.concat([cfg.handle]) : HIDE_HANDLES;
    handles.forEach(function (h) {
      document.querySelectorAll('a[href*="/products/' + h + '"]').forEach(function (a) {
        if (a.closest('[data-sp-kit]')) return;
        var hp = a.getAttribute('href') || ''; var m = hp.match(/\/products\/([^/?#]+)/); if (m && m[1] !== h) return;
        var line = a.closest(LINE_SEL) || a.closest(CARD_SEL) || a;
        if (line && !line.classList.contains('sp-hidden-line')) line.classList.add('sp-hidden-line');
      });
    });
  }

  /* ---------- re-render the cart after we changed it ---------- */
  function sectionsFor(mode) {
    if (mode !== 'dawn') return null;
    var ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer', 'cart-icon-bubble', 'cart-price');
    var mi = document.getElementById('main-cart-items'), mf = document.getElementById('main-cart-footer');
    if (mi) ids.push(mi.dataset.id || 'main-cart-items', 'cart-icon-bubble', 'cart-live-region-text', 'cart-price');
    if (mf) ids.push(mf.dataset.id || 'main-cart-footer');
    ids = ids.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    return ids.length ? ids : null;
  }
  function swapSection(el) {
    var sid = el.getAttribute('data-sp-section'), sel = el.getAttribute('data-sp-swap');
    if (!sid) return Promise.resolve();
    return fetch(root + '?sections=' + encodeURIComponent(sid) + '&t=' + Date.now(), { credentials: 'same-origin', headers: { 'X-SPKit': '1' } })
      .then(function (r) { return r.json(); }).then(function (j) {
        var html = j[sid]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var target = sel ? el.closest(sel) || document.querySelector(sel) : el.closest('form');
        if (!target) return;
        var fresh = sel ? doc.querySelector(sel) : doc.querySelector('form');
        if (fresh) target.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }
  function rerender(cart) {
    var modes = {};
    widgets().forEach(function (el) { modes[el.getAttribute('data-sp-refresh') || 'none'] = el; });
    var p = Promise.resolve();
    if (modes.impulse) document.dispatchEvent(new CustomEvent('cart:build'));
    if (modes.focal) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    if (modes.dawn && cart && cart.sections) {
      var cd = document.querySelector('cart-drawer'), ci = document.querySelector('cart-items');
      try { if (cd && cd.renderContents) cd.renderContents(cart); } catch (e) {}
      try { if (ci && ci.renderContents) ci.renderContents(cart); } catch (e) {}
      if (!(cd && cd.renderContents) && !(ci && ci.renderContents)) Object.keys(cart.sections).forEach(function (id) {
        var host = document.getElementById('shopify-section-' + id); if (!host) return;
        var doc = new DOMParser().parseFromString(cart.sections[id], 'text/html');
        var inner = doc.getElementById('shopify-section-' + id); host.innerHTML = inner ? inner.innerHTML : doc.body.innerHTML;
      });
    }
    if (modes.fn) widgets().forEach(function (el) { var x = el.getAttribute('data-sp-fn'); if (x) { try { (new Function(x))(); } catch (e) {} } });
    if (modes.section) widgets().forEach(function (el) { if (el.getAttribute('data-sp-refresh') === 'section') p = p.then(function () { return swapSection(el); }); });
    if (modes.reload && /\/cart\/?(\?|$)/.test(location.pathname + location.search)) { setTimeout(function () { location.reload(); }, 150); }
    return p.then(function () { document.dispatchEvent(new CustomEvent('spkit:synced')); });
  }

  function paint(cart, tier) {
    var lines = cart && cart.items ? cart.items.filter(isProt) : [];
    widgets().forEach(function (el) {
      var price = el.querySelector('[data-sp-price]'), note = el.querySelector('[data-sp-note]');
      if (price && tier) price.textContent = tier.label;
      if (note) note.hidden = !(lines.length && optedIn());
      el.classList.toggle('is-off', !optedIn());
      el.querySelectorAll('[data-sp-toggle]').forEach(function (t) { t.checked = optedIn(); });
    });
    hideLines();
  }

  /* core: reconcile cart with opt-in state, returns Promise<cart> */
  function sync() {
    if (!cfg && !readCfg()) return Promise.resolve(null);
    if (busy) { pending = true; return new Promise(function (res) { waiters.push(res); }); }
    busy = true;
    widgets().forEach(function (el) { el.classList.add('is-busy'); });
    var changed = false, last = null;
    var dawnSections = sectionsFor(widgets().some(function (el) { return el.getAttribute('data-sp-refresh') === 'dawn'; }) ? 'dawn' : '');
    var extra = dawnSections ? { sections: dawnSections.join(','), sections_url: location.pathname } : {};
    return getCart().then(function (cart) {
      var lines = cart.items.filter(isProt);
      var protCents = lines.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      var goodsUsd = (cart.total_price - protCents) / 100 / rate();
      var want = optedIn() ? tierFor(goodsUsd) : null;
      var keep = null;
      var ops = Promise.resolve();
      lines.forEach(function (l) {
        if (want && l.variant_id === want.id && l.quantity === 1 && !keep) { keep = l; return; }
        changed = true;
        /* percent-encoded path: same Shopify endpoint, but wishlist / "save for later" apps that sniff "/cart/change" ignore it */
        ops = ops.then(function () { return req('cart/%63hange.js', Object.assign({ id: l.key, quantity: 0 }, extra)).then(function (r) { last = r; }); });
      });
      if (want && !keep) {
        changed = true;
        ops = ops.then(function () { return req('cart/add.js', Object.assign({ items: [{ id: want.id, quantity: 1, properties: { _protection: 'sp-kit' } }] }, extra)); })
          .then(function () { return getCart(); }).then(function (c) { last = c; if (dawnSections) return fetch(root + '?sections=' + dawnSections.join(',') + '&t=' + Date.now(), { credentials: 'same-origin', headers: { 'X-SPKit': '1' } }).then(function (r) { return r.json(); }).then(function (s) { last.sections = s; }); });
      }
      return ops.then(function () { return last && last.items ? last : getCart(); }).then(function (c) { paint(c, want); return c; });
    }).then(function (c) {
      busy = false;
      widgets().forEach(function (el) { el.classList.remove('is-busy'); });
      var done = changed ? rerender(c) : Promise.resolve();
      return done.then(function () {
        paint(c, optedIn() ? tierFor((c.total_price - c.items.filter(isProt).reduce(function (s, i) { return s + i.final_line_price; }, 0)) / 100 / rate()) : null);
        if (pending) { pending = false; return sync(); }
        var w = waiters; waiters = []; w.forEach(function (res) { res(c); });
        return c;
      });
    }).catch(function (e) {
      busy = false; pending = false;
      widgets().forEach(function (el) { el.classList.remove('is-busy'); });
      var w = waiters; waiters = []; w.forEach(function (res) { res(null); });
      if (window.console) console.warn('sp-kit', e);
      return null;
    });
  }
  var debounced = (function () { var t; return function () { clearTimeout(t); t = setTimeout(sync, 350); }; })();

  /* toggle */
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-sp-toggle]')) return;
    setOpt(e.target.checked);
    sync();
  });

  /* theme events (Impulse / Dawn / Focal / Fluorescent / most themes) */
  ['cart:updated', 'ajaxProduct:added', 'cart:open', 'cart:refresh', 'cart-drawer:open', 'cart:item-added', 'quick-cart:open', 'cart:change', 'cart-notification:show'].forEach(function (ev) {
    document.addEventListener(ev, debounced);
    document.documentElement.addEventListener(ev, debounced);
  });

  /* any other cart mutation → resync (skip our own requests) */
  var ofetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var h = init && init.headers;
    var mine = h && (h['X-SPKit'] || (h.get && h.get('X-SPKit')));
    var p = ofetch.apply(this, arguments);
    if (!mine && CART_RE.test(url)) p.then(debounced, function () {});
    return p;
  };
  var oopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RE.test(url || '')) this.addEventListener('loadend', debounced);
    return oopen.apply(this, arguments);
  };

  /* keep the protection line hidden whenever the theme re-renders its cart markup */
  var mo = new MutationObserver((function () { var t; return function () { clearTimeout(t); t = setTimeout(function () { if (!cfg && readCfg()) { sync(); return; } hideLines(); widgets().forEach(function (el) { el.querySelectorAll('[data-sp-toggle]').forEach(function (x) { x.checked = optedIn(); }); }); }, 60); }; })());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* never let a checkout submit race an in-flight sync */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !/\/cart\/?$/.test((f.getAttribute('action') || '').replace(/\?.*$/, ''))) return;
    if (!busy && !pending) return;
    e.preventDefault();
    var tries = 0, wait = setInterval(function () {
      if ((!busy && !pending) || ++tries > 40) { clearInterval(wait); var b = f.querySelector('[name="checkout"]'); b ? b.click() : f.submit(); }
    }, 100);
  }, true);
  /* checkout links/buttons that go straight to /checkout: sync first */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="/checkout"], a[href*="/checkout?"]');
    if (!a || (!busy && !pending)) return;
    e.preventDefault();
    sync().then(function () { location.href = a.href; });
  }, true);

  /* AJAX "Remove" link in cart drawer/page (theme link would reload the page) — Impulse & similar */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.cart__remove a'); if (!a) return;
    var m = (a.getAttribute('href') || '').match(/[?&]id=([^&]+)/); if (!m) return;
    e.preventDefault();
    var item = a.closest('.cart__item'); if (item) item.style.opacity = '.4';
    req('cart/change.js', { id: decodeURIComponent(m[1]), quantity: 0 }).then(function () { document.dispatchEvent(new CustomEvent('cart:build')); sync(); }, function () { window.location.href = a.href; });
  });

  window.SPKit = { sync: sync, optedIn: optedIn, setOpt: setOpt, tierFor: tierFor, hideLines: hideLines };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { readCfg(); hideLines(); sync(); });
  else { readCfg(); hideLines(); sync(); }
})();
